var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 350 300",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c(
        "defs",
        [
          _c("path", {
            attrs: {
              id: "Car-Path-1",
              d:
                "M1.4 0C.6 0 0 .6 0 1.4v163c0 .8.6 1.5 1.4 1.5h61.5c.7 0 1.3-.7 1.3-1.4V1.4C64.2.6 63.6 0 63 0H1.4z",
            },
          }),
          _c("path", { attrs: { id: "Car-Path-4", d: "M0 168h297V0H0z" } }),
          _c("path", {
            attrs: {
              id: "Car-Path-6",
              d:
                "M94.5 0C60.8 0 52.6 3.2 52.6 3.2c-6.8 0-21.6 26.3-25.8 34.2-1.3-.4-2.1-1.5-2.6-2.3 0-1.4-1.1-2.7-2.8-3L12 30.4c-.5-.1-1 0-1.3.5-1.2 1.4-2.3 4-2.9 5.2a3 3 0 00-.1 2c.3 1 1 1.3 2.3 1.5l10.3 1.8c1.3.3 2.4-.2 3-1l1.4 1.6-.6 1.6a14.9 14.9 0 01-7.7 8.2c-2 .9-3.8 2.2-5.1 3.8-3.1 3.6-7.7 10-9.3 18.2C.6 80.8.7 88 1.1 93c.2 3.2-.3 6.3-1 9.5l-.1.5c0 1.3.4 20 6.4 26 0 0 .9 3 8.4 3h181c7.4 0 8.3-3 8.3-3 6-6 6.4-24.7 6.4-26v-.5c-.8-3.2-1.2-6.3-1-9.5.3-5 .4-12.2-.9-19.2a40.3 40.3 0 00-9.2-18.2c-1.4-1.6-3.1-2.9-5-3.8h-.2a14.9 14.9 0 01-7.7-8.2l-.5-1.5 1.4-1.7c.6.8 1.8 1.3 3 1l10.3-1.8c1.3-.2 2-.6 2.3-1.6a3 3 0 00-.1-2c-.5-1.2-1.6-3.7-2.9-5.1-.3-.4-.7-.6-1.2-.5l-9.6 1.7c-1.6.3-2.8 1.6-2.7 3-.5.8-1.5 2-2.7 2.3-4.3-7.9-19.1-34.2-25.9-34.2 0 0-19-3.2-52.6-3.2H94.5z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "Car-Path-2",
                x1: "0%",
                y1: "50%",
                x2: "100%",
                y2: "50%",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#646568", offset: "0%" } }),
              _c("stop", {
                attrs: { "stop-color": "#AFB1B4", offset: "100%" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "Car-Path-7",
                x1: "0%",
                y1: "50%",
                x2: "100%",
                y2: "50%",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#FEFEFE", offset: "0%" } }),
              _c("stop", {
                attrs: { "stop-color": "#D2D3D5", offset: "100%" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", {
          attrs: {
            d: "M4 0h346v300H4a4 4 0 01-4-4V4a4 4 0 014-4z",
            fill: "#ECECEC",
          },
        }),
        _c("path", {
          attrs: {
            d:
              "M298 130.2c0 4.7-3.7 8.5-8.4 8.5a8.5 8.5 0 01-8.4-8.5c0-4.7 3.7-8.5 8.4-8.5s8.4 3.8 8.4 8.5",
            fill: "#FEFEFE",
          },
        }),
        _c("path", {
          attrs: {
            d:
              "M295.5 130.4c0 3.3-2.7 6-5.9 6a5.9 5.9 0 01-5.9-6c0-3.3 2.7-6 5.9-6s5.9 2.7 5.9 6",
            fill: "#575757",
          },
        }),
        _c("path", {
          attrs: {
            d:
              "M291.5 144.3h-3.8a.7.7 0 01-.7-.7v-11.4c0-.3.3-.6.7-.6h3.8c.3 0 .6.3.6.6v11.4c0 .4-.3.7-.6.7",
            fill: "#575757",
          },
        }),
        _c("g", { attrs: { transform: "translate(258.7 78)" } }, [
          _c("mask", { attrs: { id: "Car-Path-3", fill: "#fff" } }, [
            _c("use", { attrs: { "xlink:href": "#Car-Path-1" } }),
          ]),
          _c("path", {
            attrs: {
              d:
                "M1.4 0C.6 0 0 .6 0 1.4v163c0 .8.6 1.5 1.4 1.5h61.5c.7 0 1.3-.7 1.3-1.4V1.4C64.2.6 63.6 0 63 0H1.4z",
              fill: "url(#Car-Path-2)",
              mask: "url(#Car-Path-3)",
            },
          }),
        ]),
        _c("g", { attrs: { transform: "translate(27 77)" } }, [
          _c("path", {
            attrs: {
              d:
                "M294.6 167H233c-.8 0-1.4-.7-1.4-1.4V2.4c0-.7.6-1.3 1.4-1.3h61.5c.7 0 1.3.6 1.3 1.3v163.2c0 .7-.6 1.3-1.3 1.3z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M296 160.5v5.2c0 .7-.6 1.2-1.3 1.2H233c-.7 0-1.2-.5-1.2-1.2v-5.2",
              fill: "#565656",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M296 160.5v5.2c0 .7-.6 1.2-1.3 1.2H233c-.7 0-1.2-.5-1.2-1.2v-5.2",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("mask", { attrs: { id: "Car-Path-5", fill: "#fff" } }, [
            _c("use", { attrs: { "xlink:href": "#Car-Path-4" } }),
          ]),
          _c("path", {
            attrs: {
              fill: "#FEFEFE",
              mask: "url(#Car-Path-5)",
              d: "M239.7 37H288V9.5h-48.4z",
            },
          }),
          _c("path", {
            attrs: {
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              mask: "url(#Car-Path-5)",
              d: "M239.7 37H288V9.5h-48.4z",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M273.4 63.1c0 5-4 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9M258.2 44a3 3 0 012.9 3 3 3 0 01-3 3 3 3 0 01-2.8-3 3 3 0 012.9-3M269.6 44a3 3 0 013 3 3 3 0 01-3 3 3 3 0 01-2.9-3 3 3 0 013-3",
              fill: "#FEFEFE",
              mask: "url(#Car-Path-5)",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M270.6 63.3c0 3.5-2.8 6.3-6.2 6.3a6.3 6.3 0 01-6.3-6.3 6.3 6.3 0 1112.5 0",
              fill: "#575757",
              mask: "url(#Car-Path-5)",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M266.4 78h-4a.7.7 0 01-.8-.6V65.2c0-.4.3-.7.7-.7h4.1c.4 0 .7.3.7.7v12.2c0 .4-.3.7-.7.7",
              fill: "#575757",
              mask: "url(#Car-Path-5)",
            },
          }),
          _c("path", {
            attrs: {
              fill: "#7E7F7F",
              mask: "url(#Car-Path-5)",
              d: "M239.7 37L288 9.5V37z",
            },
          }),
          _c("path", {
            attrs: {
              fill: "#F5B140",
              mask: "url(#Car-Path-5)",
              d: "M276.9 119.2l-17 29.6 4-23.3-10.5 1.8L268 92.7l-1.4 28.3z",
            },
          }),
          _c("path", {
            attrs: {
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              mask: "url(#Car-Path-5)",
              d:
                "M276.9 119.2l-17 29.6 4-23.3-10.5 1.8L268 92.7l-1.4 28.3zM262.6 67.8s-11.6-4-28.7 23.3c-16.6 26.6-39.2-4.3-55.7-4.3",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M181 157.7h27.5c1.5 0 2.7-1.3 2.7-2.8v-43.8c0-1.5-1.2-2.8-2.7-2.8H181a2.7 2.7 0 00-2.8 2.8v43.8c0 1.5 1.3 2.8 2.8 2.8M2.7 157.7h27.6c1.5 0 2.7-1.3 2.7-2.8v-43.8c0-1.5-1.2-2.8-2.7-2.8H2.7a2.7 2.7 0 00-2.7 2.8v43.8c0 1.5 1.2 2.8 2.7 2.8",
              fill: "#565656",
              mask: "url(#Car-Path-5)",
            },
          }),
        ]),
        _c("g", { attrs: { transform: "translate(28.2 79.7)" } }, [
          _c("mask", { attrs: { id: "Car-Path-8", fill: "#fff" } }, [
            _c("use", { attrs: { "xlink:href": "#Car-Path-6" } }),
          ]),
          _c("path", {
            attrs: {
              d:
                "M94.5 0C60.8 0 52.6 3.2 52.6 3.2c-6.8 0-21.6 26.3-25.8 34.2-1.3-.4-2.1-1.5-2.6-2.3 0-1.4-1.1-2.7-2.8-3L12 30.4c-.5-.1-1 0-1.3.5-1.2 1.4-2.3 4-2.9 5.2a3 3 0 00-.1 2c.3 1 1 1.3 2.3 1.5l10.3 1.8c1.3.3 2.4-.2 3-1l1.4 1.6-.6 1.6a14.9 14.9 0 01-7.7 8.2c-2 .9-3.8 2.2-5.1 3.8-3.1 3.6-7.7 10-9.3 18.2C.6 80.8.7 88 1.1 93c.2 3.2-.3 6.3-1 9.5l-.1.5c0 1.3.4 20 6.4 26 0 0 .9 3 8.4 3h181c7.4 0 8.3-3 8.3-3 6-6 6.4-24.7 6.4-26v-.5c-.8-3.2-1.2-6.3-1-9.5.3-5 .4-12.2-.9-19.2a40.3 40.3 0 00-9.2-18.2c-1.4-1.6-3.1-2.9-5-3.8h-.2a14.9 14.9 0 01-7.7-8.2l-.5-1.5 1.4-1.7c.6.8 1.8 1.3 3 1l10.3-1.8c1.3-.2 2-.6 2.3-1.6a3 3 0 00-.1-2c-.5-1.2-1.6-3.7-2.9-5.1-.3-.4-.7-.6-1.2-.5l-9.6 1.7c-1.6.3-2.8 1.6-2.7 3-.5.8-1.5 2-2.7 2.3-4.3-7.9-19.1-34.2-25.9-34.2 0 0-19-3.2-52.6-3.2H94.5z",
              fill: "url(#Car-Path-7)",
              mask: "url(#Car-Path-8)",
            },
          }),
        ]),
        _c("g", [
          _c("path", {
            attrs: {
              d:
                "M28.3 182.2c.8-3.2 1.2-6.3 1-9.5-.4-5-.5-12.2.9-19.2a40.3 40.3 0 019.2-18.2 14.5 14.5 0 015.2-3.8c3.5-1.6 6.2-4.6 7.6-8.2l.6-1.6-1.3-1.6c-.6.8-1.8 1.3-3 1L38 119.3c-1.2-.2-2-.6-2.3-1.6a3 3 0 01.2-2c.5-1.2 1.6-3.7 2.8-5.1.3-.4.8-.6 1.3-.5l9.6 1.7c1.6.3 2.8 1.6 2.7 3 .5.7 1.4 1.9 2.6 2.2 4.3-7.8 19-34 25.9-34 0 0 8.1-3.3 41.9-3.3h10.7c33.7 0 52.6 3.2 52.6 3.2 6.8 0 21.7 26.3 26 34.2 1.2-.4 2.1-1.5 2.6-2.3-.1-1.4 1-2.7 2.7-3l9.6-1.7c.5-.1 1 0 1.3.5 1.2 1.4 2.3 4 2.8 5.2.3.6.4 1.3.2 2-.3 1-1 1.3-2.3 1.5l-10.4 1.8c-1.2.3-2.4-.2-3-1l-1.4 1.7.6 1.5c1.4 3.6 4.1 6.6 7.7 8.2 0 0 0 0 0 0 2 .9 3.7 2.2 5.1 3.8 3 3.6 7.7 10 9.2 18.2 1.4 7 1.3 14.2 1 19.2a31 31 0 001 10c0 1.3-.5 20-6.5 26 0 0-.8 3-8.4 3H43.1c-7.6 0-8.4-3-8.4-3-6-6-6.5-24.7-6.5-26l.1-.5z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M142.3 162.3l3.7-7.2c.1-.2.3-.3.5-.3l40.3-4.3c.4 0 .8.4.7.8l-1.9 6.9c0 .2-.3.4-.5.4l-42.2 4.6a.6.6 0 01-.6-.9",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M142.3 162.3l3.7-7.2c.1-.2.3-.3.5-.3l40.3-4.3c.4 0 .8.4.7.8l-1.9 6.9c0 .2-.3.4-.5.4l-42.2 4.6a.6.6 0 01-.6-.9z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M127 162.3l-3.8-7.2c0-.2-.3-.3-.5-.3l-40.3-4.3c-.4 0-.7.4-.6.8l1.8 6.9c0 .2.3.4.5.4l42.2 4.6c.5 0 .8-.4.6-.9",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M127 162.3l-3.8-7.2c0-.2-.3-.3-.5-.3l-40.3-4.3c-.4 0-.7.4-.6.8l1.8 6.9c0 .2.3.4.5.4l42.2 4.6c.5 0 .8-.4.6-.9z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M229 192.4l-.6 6c-.3 1.9-1.9 3.3-3.8 3.6l-5.1.9c-2.5.4-5 0-7.2-1-2.7-1.4-5.8-3.6-6.8-7.4 0 0-1.3-2.6 1.5-3l19.2-1.7c1.5-.1 2.8 1 2.7 2.6",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M229 192.4l-.6 6c-.3 1.9-1.9 3.3-3.8 3.6l-5.1.9c-2.5.4-5 0-7.2-1-2.7-1.4-5.8-3.6-6.8-7.4 0 0-1.3-2.6 1.5-3l19.2-1.7c1.5-.1 2.8 1 2.7 2.6z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M40.2 192.4c0 1.7.2 4 .5 6 .4 1.9 2 3.3 3.8 3.6l5.1.9c2.5.4 5 0 7.3-1 2.6-1.4 5.8-3.6 6.7-7.4 0 0 1.3-2.6-1.5-3l-19.2-1.7c-1.5-.1-2.7 1-2.7 2.6",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M40.2 192.4c0 1.7.2 4 .5 6 .4 1.9 2 3.3 3.8 3.6l5.1.9c2.5.4 5 0 7.3-1 2.6-1.4 5.8-3.6 6.7-7.4 0 0 1.3-2.6-1.5-3l-19.2-1.7c-1.5-.1-2.7 1-2.7 2.6z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M224.9 144c-3.7 0-15.9-1.4-30.5 3.8-.3.2-.6.3-.6.6v12.7c0 .4.3.6.7.6 3.8 0 23-.9 34-5.5.3-.1.5-.4.4-.7l-3.2-11c0-.4-.4-.5-.8-.5",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M224.9 144c-3.7 0-15.9-1.4-30.5 3.8-.3.2-.6.3-.6.6v12.7c0 .4.3.6.7.6 3.8 0 23-.9 34-5.5.3-.1.5-.4.4-.7l-3.2-11c0-.4-.4-.5-.8-.5z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M38.5 144c3.7 0 15.9-1.4 30.4 3.8.4.2.7.3.7.6v12.7c0 .4-.3.6-.7.6-3.9 0-23-.9-34-5.5-.3-.1-.5-.4-.4-.7l3.2-11c0-.4.4-.5.8-.5",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M38.5 144c3.7 0 15.9-1.4 30.4 3.8.4.2.7.3.7.6v12.7c0 .4-.3.6-.7.6-3.9 0-23-.9-34-5.5-.3-.1-.5-.4-.4-.7l3.2-11c0-.4.4-.5.8-.5z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M74.8 120a355 355 0 00117.4 0c4-.6 6.5-3.5 5.8-6.2l-3.7-14c-.7-2.6-4.2-5.5-7.7-6.1-35-6-71.3-6-106.2 0-3.5.6-7 3.5-7.7 6.2L69 113.8c-.8 2.7 1.8 5.6 5.7 6.3",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M74.8 120a355 355 0 00117.4 0c4-.6 6.5-3.5 5.8-6.2l-3.7-14c-.7-2.6-4.2-5.5-7.7-6.1-35-6-71.3-6-106.2 0-3.5.6-7 3.5-7.7 6.2L69 113.8c-.8 2.7 1.8 5.6 5.7 6.3z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M93.9 122.8c32.6 3.6 66 2.7 98.3-2.7 4-.7 6.5-3.6 5.8-6.3l-3.7-14c-.7-2.6-4.2-5.5-7.7-6.1a320.2 320.2 0 00-56.2-4.4",
              fill: "#7E7F7F",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M79.5 204h108.8c2.2 0 3.7-1.7 3.2-3.9l-3.8-16.2c-.5-2.1-2.6-3.9-4.6-3.9H84.7c-2 0-4.1 1.8-4.6 4L76.3 200c-.5 2.2 1 4 3.2 4",
              fill: "#FEFEFE",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M79.5 204h108.8c2.2 0 3.7-1.7 3.2-3.9l-3.8-16.2c-.5-2.1-2.6-3.9-4.6-3.9H84.7c-2 0-4.1 1.8-4.6 4L76.3 200c-.5 2.2 1 4 3.2 4z",
              stroke: "#7E7F7F",
              "stroke-width": "1.9",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }